export function addTenantRequestContext(config, tenantSlug) {
  if (!config.excludeTenantSlug && tenantSlug) {
    config.headers['X-Kairon-Tenant-Slug'] = tenantSlug
  }
  return config
}
